module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/spinner-bd644c91ad234e0fc9cb574e6cf6e526.svg";